import { HttpResponse } from '@angular/common/http';

/**
 * Shared ETag helpers for optimistic concurrency.
 *
 * Convention used across the app (grid layouts, avatars, …):
 * - Store / cache the token **without** quotes (`0x8DF…`)
 * - Send it on the wire as a quoted query value (`version="0x8DF…"`)
 */

/** Strip surrounding quotes for in-memory / cache use. */
export function parseEtag(value: string | null | undefined): string | null {
    if (value == null) {
        return null;
    }

    const trimmed = value.trim();
    if (!trimmed) {
        return null;
    }

    return trimmed.replaceAll('"', '') || null;
}

/** Format an ETag for an API `version` query parameter. */
export function formatEtagForQuery(version: string | null | undefined): string | undefined {
    const clean = parseEtag(version);
    return clean ? `"${clean}"` : undefined;
}

/** Read and normalize the ETag header from an HTTP response. */
export function etagFromResponse(response: HttpResponse<unknown>): string | null {
    return parseEtag(response.headers.get('ETag'));
}
